export default {"src":"/_next/static/media/IFF.d7985799.svg","height":18,"width":18};